//TODO: remove once we implement on backend
function toCamelCase(s: string): string {
  return s.replace(/([-_][a-z0-9])/g, (group) => group.toUpperCase().replace('-', '').replace('_', ''))
}

export function convertKeysToCamelCase(obj: any): any {
  if (Array.isArray(obj)) {
    return obj.map((v) => convertKeysToCamelCase(v))
  } else if (obj !== null && typeof obj === 'object') {
    return Object.keys(obj).reduce((result: Record<string, any>, key: string) => {
      const newKey = toCamelCase(key)
      result[newKey] = convertKeysToCamelCase(obj[key])
      return result
    }, {})
  }
  return obj
}
